<template>
  <v-layout row>
    <v-flex xs12 pa-5>
      <v-card
        tile
        class="mx-auto">
        <v-list>
          <v-list-item-content>
            <v-list-item-subtitle class="pl-4" style=" font-size: 0.86em;">
              Report Categories
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content class="mb-4" >
            <PublicReportCategories/>
          </v-list-item-content>
        </v-list>
      </v-card>
    </v-flex>
   <v-snackbar
      id="snack"
      color="#339966"
      v-model="snackbar"
      right
      style="position: fixed; "
      class="mb-6 ma-19">
      <v-layout class="pa-4">
        <span name="app" dark style=" font-size: 0.8em;"><v-icon color="white"> {{snackbarError.icon}}</v-icon> {{snackbarError.label}}  </span>
        <v-spacer/>
      </v-layout>
   </v-snackbar>
   <template>
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        scrollable
        max-width="780"
      >
        <v-card tile class="">
          <v-card-title class="subtitle-1 grey lighten-5 body-2">
            <v-icon color="red" class="mr-1">mdi-scale-balance</v-icon>
            Agreement
          </v-card-title>
          <v-card-text class="pb-2 pt-4 dialog-text-size">You are accessing a Ministry of Health Malawi information system dabbed Malawi Analytics Platform (MAP) / Malawi Healthcare Analytics Platform (MHAP), which includes (i) this information system; (ii) this information system’s data; (iii) all information systems connected to this platform; and (iv) all analytics and data sources attached to this information system. This information system is provided for the MOH Malawi-authorized use only.</v-card-text>
          <v-card-text class="pb-2 dialog-text-size">Unauthorized or improper use of this system may result in disciplinary action, as well as civil and criminal penalties.</v-card-text>
          <v-card-text class="pb-2 dialog-text-size">By using this information system, you understand and consent to the following:</v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="gray" small>
                  mdi-record
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-wrap dialog-text-size">You have no reasonable expectation of privacy regarding any communications or data transiting or stored on this information system. At any time, and for any lawful government purpose, the government may monitor, intercept, and search and seize any communication or data transiting or stored on this information system.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="gray" small>
                  mdi-record
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-wrap dialog-text-size">Any communications or data transiting or stored on this information system may be disclosed or used for any lawful government purpose.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="gray" small>
                  mdi-record
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-wrap">Nothing herein consents to the search or seizure of a privately owned information system or other privately owned communications devices, or the contents thereof that is in the system user’s home</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle class="text-wrap font-weight-medium" style="font-size: 0.80em;">USE OF THIS COMPUTER SYSTEM OR NETWORK BY ANY USER, AUTHORIZED OR UNAUTHORIZED, CONSTITUTES EXPRESS CONSENT TO THIS MONITORING. IF YOU DO NOT CONSENT TO THIS MONITORING, OR IF YOU ARE NOT AN AUTHORIZED USER, YOU SHOULD EXIT THIS SYSTEM. IF YOU ARE AN AUTHORIZED USER AND CONSENT, SELECT "I AGREE" TO THE SYSTEM TERMS AND USAGE TO INDICATE YOU AGREE TO ALL THE CONDITIONS STATED HEREIN.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions class=" grey lighten-5">
            <v-spacer></v-spacer>
            <v-btn
              dark
              text
              small
              color="green darken-1"
              @click="closeInitDialog"
              class="mb-2"
            >
              Agree & Stay Logged Out
            </v-btn>
            <v-btn
              dark
              text
              small
              color="green darken-1"
              @click="goToLogin()"
              class="mb-2"
            >
              Agree & Login
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-layout>
</template>

<script>
import PublicReportCategories from '@/components/PublicReportCategories'

export default {
  name: 'App',
  props: {
    source: String
  },
  data: () => {
    return {
      reportName: '',
      snackbar: false,
      dialog: true,
      search: null,
      items: [],
      headers: [ { text: 'Report Name', value: 'name' },
        { text: 'Date Uploaded', value: 'date_uploaded' },
        { text: 'Report Type', value: 'type' }
      ],
      snackbarError: { icon: 'mdi-server-network-off', label: 'Network error, cannot load the report, please check your network.' }
    }
  },
  components: {
    PublicReportCategories
  },
  mounted: [
    function () {
      localStorage.clear()
      // get the quest parameters
      const perform = this.$route.query.perform
      localStorage.setItem('perform', perform)
    }
  ],
  methods: {
    goToLogin () {
      this.$router.push('/login')
    },
    closeInitDialog () {
      this.dialog = false
    },
    loadReport (item) {
      this.reportName = item.type
      var userId = localStorage.getItem('kwkk')
      var reportId = item.id
      window.axios.post('/viewership/insert', { userId: userId, reportId: reportId })
        .then((response) => {
          const viewershipId = response.data.insertId
          localStorage.setItem('viewershipId', viewershipId)
          localStorage.setItem('name', item.name)
          localStorage.setItem('link', item.link)
          localStorage.setItem('dateCreated', item.date_created)
          localStorage.setItem('author', item.report_by)
          if (item.type === 'Power Bi') {
            this.dialog = true
            const reportId = item.report_id
            const datasetId = item.dataset_id
            const embedUrl = item.embed_url
            window.axios.post('/viewership/getEmbedToken', { reportId: reportId, datasetId: datasetId })
              .then(async (response) => {
                const token = response.data.token
                this.dialog = false
                const passphrase = process.env.VUE_APP_PASSPHRASE
                const encryptedToken = this.CryptoJS.AES.encrypt(token, passphrase).toString()
                const encryptedReportId = this.CryptoJS.AES.encrypt(reportId, passphrase).toString()
                const encryptedEmbedUrl = this.CryptoJS.AES.encrypt(embedUrl, passphrase).toString()
                const encryptedName = this.CryptoJS.AES.encrypt(item.name, passphrase).toString()
                const encryptedDatasetId = this.CryptoJS.AES.encrypt(datasetId, passphrase).toString()
                localStorage.setItem('name', encryptedName)
                localStorage.setItem('tken', encryptedToken)
                localStorage.setItem('reportId', encryptedReportId)
                localStorage.setItem('embUrl', encryptedEmbedUrl)
                localStorage.setItem('datasetId', encryptedDatasetId)
                this.$router.push('userPowerBiVisual')
              })
              // eslint-disable-next-line handle-callback-err
              .catch(() => {
                this.snackbar = true
                this.dialog = false
              })
          } else if (item.type === 'Web Embed' || item.type === 'Dash') {
            this.dialog = true
            this.dialog = false
            const embedUrl = item.embed_url
            const passphrase = process.env.VUE_APP_PASSPHRASE
            const encryptedEmbedUrl = this.CryptoJS.AES.encrypt(embedUrl, passphrase).toString()
            const encryptedName = this.CryptoJS.AES.encrypt(item.name, passphrase).toString()
            localStorage.setItem('name', encryptedName)
            localStorage.setItem('embUrl', encryptedEmbedUrl)
            this.$router.push('userSeeWebMap')
          } else {
            // this.$router.push('userJavaScriptVisual')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    }
  }
}
</script>
<style scoped>
.v-text-field >>> input {
  font-size: 0.84em;
}
.v-text-field >>> label {
  font-size: 0.84em;
}

.dialog-text-size {
  font-size: 0.78rem;
}

</style>
